(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-filter-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
      Alpine.data('quickFilterButtons', () => ({
        toggleFilter(filterId, buttonEl) {
          const drawer = buttonEl.closest('.mobile-facets__wrapper');
          if (!drawer) return;
  
          const drawerDisclosure = drawer.querySelector('.mobile-facets__disclosure');
          const isDrawerOpen = drawerDisclosure?.hasAttribute('open');
  
          if (isDrawerOpen) {
            this.openFilter(filterId);
          } else {
            this.openDrawerAndFilter(drawer, filterId);
          }
        },
  
        openFilter(filterId) {
          const filterDetails = document.getElementById(filterId);
          if (!filterDetails) return;
  
          const filterSummary = filterDetails.querySelector('.mobile-facets__summary');
          if (filterSummary && !filterDetails.hasAttribute('open')) {
            filterSummary.click();
          }
        },
  
        openDrawerAndFilter(drawer, filterId) {
          const drawerSummary = drawer.querySelector('summary');
          if (!drawerSummary) return;
  
          drawerSummary.click();
          this.$nextTick(() => this.openFilter(filterId));
        },
      }));
    });
  } catch(e) { console.error(e); }
})();

})();
